import PropTypes from "prop-types"
import React from "react"

import { getPlanData } from "views/User/views/Plans/helpers/plans"

const PlanIcon = ({ name, type }) => (
  <img src={getPlanData(name, type).icon} alt="Plan icon" className="m-b-10" />
)

PlanIcon.propTypes = {
  name: PropTypes.string,
  type: PropTypes.string,
}

PlanIcon.defaultProps = {
  name: "",
  type: "",
}

export default PlanIcon
